/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@eureca/candidate-api-sdk/client';
import type {
  GetOnboardingProgressQueryResponse,
  GetOnboardingProgress401,
  GetOnboardingProgress404,
} from '../types/GetOnboardingProgress.ts';
import type { Client, RequestConfig, ResponseErrorConfig } from '@eureca/candidate-api-sdk/client';

function getGetOnboardingProgressUrl() {
  const res = { method: 'GET', url: `/onboarding/progress` as const };
  return res;
}

/**
 * {@link /onboarding/progress}
 */
export async function getOnboardingProgress(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetOnboardingProgressQueryResponse,
    ResponseErrorConfig<GetOnboardingProgress401 | GetOnboardingProgress404>,
    unknown
  >({ method: 'GET', url: getGetOnboardingProgressUrl().url.toString(), ...requestConfig });
  return res.data;
}
